export interface CountryPhoneCode {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
}

export const COUNTRY_PHONE_CODES: CountryPhoneCode[] = [
  {
    name: "Kenya",
    code: "KE",
    dialCode: "+254",
    flag: "🇰🇪",
  },
  {
    name: "Uganda",
    code: "UG",
    dialCode: "+256",
    flag: "🇺🇬",
  },
  {
    name: "Tanzania",
    code: "TZ",
    dialCode: "+255",
    flag: "🇹🇿",
  },
  {
    name: "Rwanda",
    code: "RW",
    dialCode: "+250",
    flag: "🇷🇼",
  },
  {
    name: "Ethiopia",
    code: "ET",
    dialCode: "+251",
    flag: "🇪🇹",
  },
  {
    name: "Nigeria",
    code: "NG",
    dialCode: "+234",
    flag: "🇳🇬",
  },
  {
    name: "South Africa",
    code: "ZA",
    dialCode: "+27",
    flag: "🇿🇦",
  },
  {
    name: "Ghana",
    code: "GH",
    dialCode: "+233",
    flag: "🇬🇭",
  },
  {
    name: "Egypt",
    code: "EG",
    dialCode: "+20",
    flag: "🇪🇬",
  },
  {
    name: "Morocco",
    code: "MA",
    dialCode: "+212",
    flag: "🇲🇦",
  },
  {
    name: "United Kingdom",
    code: "GB",
    dialCode: "+44",
    flag: "🇬🇧",
  },
  {
    name: "United States",
    code: "US",
    dialCode: "+1",
    flag: "🇺🇸",
  },
  {
    name: "Canada",
    code: "CA",
    dialCode: "+1",
    flag: "🇨🇦",
  },
];

// Regex pattern from backend validation
export const PHONE_NUMBER_PATTERN = /^(\+?[1-9]\d{1,14}|0\d{9,14})$/;

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) return false;
  return PHONE_NUMBER_PATTERN.test(phoneNumber);
};

export const formatPhoneNumber = (
  phoneNumber: string,
  dialCode: string
): string => {
  // Remove all non-digit characters except +
  let cleaned = phoneNumber.replace(/[^\d+]/g, "");

  // If it starts with 0 and doesn't have a country code, prepend the dial code
  if (cleaned.startsWith("0")) {
    cleaned = dialCode + cleaned.substring(1);
  } else if (!cleaned.startsWith("+")) {
    // If no + and no 0, add the dial code
    cleaned = dialCode + cleaned;
  }

  return cleaned;
};
